import script from "./WksOpenInputBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksOpenInputBtn.vue?vue&type=script&setup=true&lang=ts"

import "./WksOpenInputBtn.vue?vue&type=style&index=0&id=95fb95ce&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95fb95ce"]])

export default __exports__